module.exports = __webpack_public_path__ + "static/media/poster13.b3cb9642.png";